// Polyfills for js features used in the Dashboard but not supported in some browsers (mainly IE)
import '@/polyfills';

import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { Input, Tooltip, Popover } from 'element-ui';
import GlobalDirectives from './globalDirectives';
import { ValidationProvider } from 'vee-validate';

import '@/assets/sass/argon.scss'
import '@/assets/css/nucleo/css/nucleo.css';

// router setup
import router from './routes/router';

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(Input.name, Input)
Vue.use(Tooltip)
Vue.use(Popover)
Vue.use(GlobalDirectives)
Vue.component('validation-provider', ValidationProvider)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
